<template>
    <div v-if="!available_spaces.loading && available_spaces.data.results.length > 0">
        <h1 class="title">
            Available Spaces
            <i v-if="join_request.loading" class="loader is is-pulled-right"></i>
        </h1><br/>

        <div class="columns is-multiline">
            <div v-for="space in available_spaces.data.results || []"
                 class="column  is-4-desktop is-3-fullhd is-6-tablet"
                 :key="space.id">

                <div class="card space-card">
                    <div class="card-header">
                        <div class="card-header-title">{{ space.name }}</div>

                        <a v-if="!space.requested"
                           @click="send_request(space)"
                           class="card-header-icon">
                            <i class="icon fas fa-plus-square"></i>
                        </a>

                        <p v-else class="card-header-icon has-text-grey">requested</p>
                    </div>

                    <div class="card-content">
                        <div v-if="space.description">{{space.description}}</div>
                        <div v-else class="has-text-grey">No description</div>
                    </div>

                    <div class="card-footer has-text-grey">
                        <div class="is-pulled-left">
                            <i class="icon fas fa-user-friends"></i>
                            {{space.members_count}}
                        </div> &nbsp;

                        <div class="is-pulled-right">
                            <i class="icon fas fa-copy"></i>
                            {{space.notes_count}}
                        </div>

                        <div class="is-clearfix"></div>
                    </div>
                </div>
            </div>
        </div>

        <base-paginator
            parameter="available_spaces_page"
            :current="parseInt($route.query.available_spaces_page || 1)"
            :total-count="available_spaces.data.count || 0"
            :per-page="15"/>
    </div>

    <div v-else-if="available_spaces.loading" class="loader title"></div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'SpaceAvailableList',
    computed: mapState('spaces', ['available_spaces', 'join_request']),
    created() {
        this.load();
    },
    watch: { $route: 'load' },
    methods: {
        load() {
            this.$store.dispatch('spaces/available_spaces', {
                page: this.$route.query.available_spaces_page || 1,
            });
        },
        send_request(space) {
            // eslint-disable-next-line no-restricted-globals,no-alert
            if (confirm('Do you what to send join request?')) {
                this.$store.dispatch('spaces/join_request', { space_id: space.id }).then(() => {
                    this.$store.commit('spaces/change_request_status', {
                        id: space.id,
                        requested: true,
                    });
                });
            }
        },
    },
};
</script>
